import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

/**
 * OverdueBlip — a small pulsing "radar" dot marking an overdue due date. An 8px
 * solid dot with an expanding-then-fading ring behind it. Ports design.tsx
 * `OverdueBlip` (~lines 307–318). Honours prefers-reduced-motion.
 */
const blip = keyframes`
  0%        { transform: scale(1);   opacity: 0.55; }
  80%, 100% { transform: scale(2.6); opacity: 0; }
`;

export const OverdueBlip = () => (
  <Box position="relative" w="8px" h="8px" flexShrink={0} aria-hidden>
    <Box
      position="absolute"
      inset="0"
      borderRadius="full"
      bg="error.500"
      animation={`${blip} 1.6s cubic-bezier(0, 0, 0.2, 1) infinite`}
      sx={{ "@media (prefers-reduced-motion: reduce)": { animation: "none" } }}
    />
    <Box position="absolute" inset="0" borderRadius="full" bg="error.500" />
  </Box>
);

export default OverdueBlip;
